import { createReducer, on } from '@ngrx/store';

import { collapse, expand, hide, show, toggle } from '../actions/feature-panel.actions';

export const panelFeatureKey = 'featurePanel';

export interface FeaturePanelState {
  expanded: boolean;
  showing: boolean;
}

export const initialState: FeaturePanelState = {
  expanded: false,
  showing: true
};

const reducer = createReducer(
  initialState,
  on(expand, (state) => ({ ...state, expanded: true })),
  on(collapse, (state) => ({ ...state, expanded: false })),
  on(toggle, (state) => ({ ...state, expanded: !state.expanded })),
  on(show, (state) => ({ ...state, showing: true })),
  on(hide, (state) => ({ ...state, showing: false }))
);

export function featurePanelReducer(state, action): FeaturePanelState {
  return reducer(state, action);
}
